var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticStyle:{"font-size":"16px","font-style":"normal","font-weight":"400","line-height":"29px","letter-spacing":"0.04em","text-align":"left"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }